import "./style.css";
import Particles from "../Particles/Particles";

const AboutUs = () => {
  return (
    <>
      <Particles title="Explore Us" />
      <div className="about-us-container">
        <h2>About Us</h2>
        <p>
          Welcome to <strong>Educraft Education Network</strong> — your trusted
          partner for building a brighter future. We are a team of passionate
          and friendly experts. Our mission is to guide students, professionals,
          and dreamers at every step of their journey abroad. Whether you want
          to study in a top university, move abroad for work, or start a new
          career, we are here to support you. We listen to your goals and create
          a plan that fits your dreams. At Educraft, we believe that every
          journey is unique. That’s why we offer personalized advice,
          step-by-step guidance, and complete support — from choosing the right
          course or country to getting your visa approved. We work with trusted
          universities and partners around the world. With us, you are never
          alone in your journey.
          <br />
        </p>
        <i>
          `Let’s open the doors to your future together. Your dream. Our
          mission.`
        </i>
      </div>
      <div className="our-services">
        <h1>What We Do</h1>
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="card">
              <h4>🎓 Education Consultancy</h4>
              <p>
                Admission guidance, university selection, and application
                support.
              </p>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="card">
              <h4>🌍 Immigration Services</h4>
              <p>Visa consultation, documentation, and process handling.</p>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="card">
              <h4>🧭 Career Counselling</h4>
              <p>Skill assessment and pathway planning for a global career.</p>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="card">
              <h4>🧪 Test Preparation</h4>
              <p>Coaching for IELTS & PTE exams with mock test service.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
